/* eslint-disable eqeqeq */
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import OutsideClickHandler from "react-outside-click-handler";

import {
  SelectWrapper,
  SelectedOptionWrapper,
  SelectLists,
  SelectList,
} from "./select.style";

export default function Select({
  selected,
  options,
  setSelected,
  index,
  thirdOption,
  title,
  onClick,
  disabled,
  color,
  ring,
  ringWhite,
  extraTitle,
  selectPrefix = true,
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {}, [open]);
  return (
    <SelectWrapper
      className={`${disabled ? "disabled " : ""}${ring ? "ring-1 " : ""}${
        ringWhite ? "ring-white" : ""
      }`}
      style={{
        pointerEvents: disabled ? "none" : "",
      }}
      color={color}
    >
      <SelectedOptionWrapper color={color}>
        {selected ? (
          options
            .filter(
              (option) =>
                option.id == selected ||
                option[index] == selected ||
                option[thirdOption] == selected
            )
            .map((item, i) => (
              <p key={i}>
                {item[index]} {extraTitle ? item[extraTitle] : ""}
              </p>
            ))
        ) : (
          <span>
            {" "}
            {selectPrefix ? "Select" : ""} {title}
          </span>
        )}
      </SelectedOptionWrapper>
      <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
        <SelectLists hide={open}>
          {options &&
            options.map((item, ind) => {
              let active = false;
              if (selected && selected[index] == item[index]) {
                active = true;
              }
              return (
                <SelectList
                  onClick={() => {
                    setSelected(item);
                    setOpen(true);
                    if (onClick) {
                      onClick();
                    }
                  }}
                  key={ind}
                  // key={item[index]}
                  active={active}
                >
                  {item[index]} {extraTitle ? item[extraTitle] : ""}
                </SelectList>
              );
            })}
        </SelectLists>
      </OutsideClickHandler>
    </SelectWrapper>
  );
}
Select.propTypes = {
  extraTitle: PropTypes.string,
};

Select.defaultProps = {
  extraTitle: null,
};
